import {profile} from 'constants/url';
import useAdd from 'components/hooks/useAdd';
import {AddingOptions} from 'components/grid-dx/types';

function useAddProfile() {
  const addProfile = useAdd(profile);
  return (addingOptions: AddingOptions) => addProfile(addingOptions);
}

export default useAddProfile;
